module.exports = __webpack_public_path__ + "static/utisemi-intensiva-bebe-5ca1d72193ee18d4dac7d9666e8e21c4.jpg";